import React from 'react';
import './TranscriptParagraph.css';

const TranscriptParagraph = ({ paragraph }) => {
  const { speaker, displayDuration, text } = paragraph;

  return (
    <div className="transcript-paragraph">
      <div className="transcript-paragraph-header">
        {speaker ? (
          <>
            <span className="transcript-speaker">{speaker}</span>
            <span className="transcript-duration">{displayDuration}</span>
          </>
        ) : (
          <span className="transcript-duration-only">{displayDuration}</span>
        )}
      </div>
      <div className="transcript-text-content">
        {text}
      </div>
    </div>
  );
};

export default TranscriptParagraph;
